import type {
  LoginInputType,
  LoginOutputType,
  ResetarSenhaInputType,
  SolicitarResetInputType,
  UsuarioLogadoOutputType,
} from '../../../shared/dto';
import { callApi } from './call-api';

export const authApi = {
  login: (body: LoginInputType) =>
    callApi<LoginOutputType>({
      method: 'POST',
      path: '/auth/login',
      body,
    }),

  logout: (_args: void) => callApi<void>({ method: 'POST', path: '/auth/logout' }),

  me: (_args: void) => callApi<UsuarioLogadoOutputType>({ path: '/me' }),

  solicitarReset: (body: SolicitarResetInputType) =>
    callApi<void>({
      method: 'POST',
      path: '/auth/solicitar-reset',
      body,
    }),

  resetarSenha: (body: ResetarSenhaInputType) =>
    callApi<void>({
      method: 'POST',
      path: '/auth/resetar-senha',
      body,
    }),
};
